import { cn } from "@tellescope/ui";

interface OptionDetail {
  option: string;
  description?: string;
}

interface CardOptionButtonProps {
  option: OptionDetail;
  selected: boolean;
  onSelect: () => void;
  invalid: boolean;
  autoFocus?: boolean;
}

export const CardOptionButton = ({ option, selected, onSelect, invalid, autoFocus }: CardOptionButtonProps) => (
  <button
    type="button"
    onClick={onSelect}
    aria-pressed={selected}
    autoFocus={autoFocus}
    className={cn(
      "w-full flex flex-col items-start gap-1 p-4 border rounded-md text-left transition-colors cursor-pointer",
      "hover:bg-gray-100 ",
      selected && "border-primary bg-primary/10",
      invalid && "border-destructive"
    )}
  >
    <span className="font-medium">{option.option}</span>
    {!!option.description && <span className="text-sm text-muted-foreground">{option.description}</span>}
  </button>
);
